import { extractErrorType } from './extractErrorType.mjs';

const errorMessages = {
    invalid_email: {
        id: "error.invalidEmail"
    },
    invalid_phone_number: {
        id: "error.invalidPhoneNumber"
    },
    unsubscribed_phone_number: {
        id: "error.unsubscribedPhoneNumber"
    },
    inactive_email: {
        id: "error.inactiveEmail"
    },
    unauthorized_credentials: {
        id: "error.unauthorizedCredentials"
    },
    user_unauthenticated: {
        id: "error.userUnauthenticated"
    },
    email_not_found: {
        id: "error.emailNotFound"
    },
    unable_to_auth_magic_link: {
        id: "error.unableToAuthMagicLink"
    },
    no_user_password: {
        id: "error.noUserPassword"
    },
    breached_password: {
        id: "error.breachedPassword"
    },
    reset_password: {
        id: "error.resetPassword"
    },
    oauth_token_not_found: {
        id: "error.oauthTokenNotFound"
    },
    invalid_code: {
        id: "error.invalidCode"
    },
    member_password_not_found: {
        id: "error.memberPasswordNotFound"
    },
    oauth_flow_callback_error: {
        id: "error.oauthFlowCallbackError"
    },
    unauthorized_action: {
        id: "error.unauthorizedAction"
    },
    user_lock_limit_reached: {
        id: "error.userLockLimitReached"
    },
    invalid_session_token: {
        id: "error.invalidSessionToken"
    },
    session_not_found: {
        id: "error.sessionNotFound"
    },
    invalid_phone_number_country_code: {
        id: "error.invalidPhoneNumberCountryCode"
    },
    otp_code_not_found: {
        id: "error.otpCodeNotFound"
    },
    duplicate_member_phone_number: {
        id: "error.duplicatePhoneNumber"
    }
};
/**
 * This method is meant to be a catch all for errors that don't require special handling.
 * It will return a translated error message for the error type.
 * If the error type is not included here, it will return the error message as an untranslated string.
 */ const getTranslatedError = (error, t)=>{
    const errorType = extractErrorType(error);
    const messageDescriptor = errorMessages[errorType];
    if (messageDescriptor) {
        return t(messageDescriptor);
    }
    return error.error_message;
};

export { getTranslatedError };
//# sourceMappingURL=getTranslatedError.mjs.map
